export const mpvueInfo = state => state.mpvueInfo
export const title = state => state.title
export const profile = state => state.profile
export const taxonomyList = state => state.taxonomyList



// WEBPACK FOOTER //
// ./src/store/getters.js